// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScrollToTop_scrollTopBtn__hdcht {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 45px;
  height: 45px;
  background: black;
  color: white;
  border: solid 2px black;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease-in-out;
}

.ScrollToTop_scrollTopBtn__hdcht:hover {
  background: transparent;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/Layout/SconllToTop/ScrollToTop.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,0CAAA;EACA,oCAAA;AACJ;;AAEE;EACE,uBAAA;EACA,YAAA;AACJ","sourcesContent":[".scrollTopBtn {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    width: 45px;\n    height: 45px;\n    background: black;\n    color: white;\n    border: solid 2px black;\n    border-radius: 6px;\n    font-size: 20px;\n    cursor: pointer;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    transition: opacity 0.3s ease-in-out;\n  }\n  \n  .scrollTopBtn:hover {\n    background: transparent;\n    color: black;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollTopBtn": `ScrollToTop_scrollTopBtn__hdcht`
};
export default ___CSS_LOADER_EXPORT___;
